import * as React from "react";
import { useTheme } from "@mui/material/styles";
import {
	Box,
	Radio,
	FormGroup,
	FormControlLabel,
	MobileStepper,
	Button,
	Paper,
	Typography,
} from "@mui/material";
import Image from "../../../ui-components/Image";

import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

let loadSelection = [];

export default function MatchText({ question, onAnswer = () => {} }) {
	let selection = [];
	const [activeStep, setActiveStep] = React.useState(0);
	const maxSteps = question.totalQuestions;
	const theme = useTheme();
	const [answer, setAnswer] = React.useState({});

	React.useEffect(() => {
		// reset proceed button
		setAnswer({});
		loadSelection = [];
		setActiveStep(0);
	}, [question]);

	const handleSetAnswer = (name, ansText) => {
		let ans = { ...answer };
		ans[String(name)] = ansText;
		setAnswer(ans);

		const canProceed = Object.keys(ans).length === question.totalQuestions;

		onAnswer({
			canProceed,
			answer: ans,
		});
	};

	Object.values(question.questionList).forEach((q) => {
		selection.push(q.name);
	});

	if (loadSelection.length === 0) {
		const getSelection = question.questionChoices || selection;
		loadSelection = getSelection
			.map((a) => ({ sort: Math.random(), value: a }))
			.sort((a, b) => a.sort - b.sort)
			.map((a) => a.value);
	}

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	return (
		<React.Fragment>
			{typeof question?.questionList[activeStep] !== "undefined" && (
				<>
					<Box
						sx={{
							width: "100%",
							background: "white",
							pb: 2,
							pt: 1,
							px: 1,
						}}
						className="image-container"
					>
						{question.questionList[activeStep].type !== "image" && (
							<Paper sx={{ fontSize: "6rem", mb: 2 }}>
								{[
									question.questionList[activeStep].label
										.split(
											question.questionList[activeStep]
												.mark
										)
										.map((lbl) => {
											if (!lbl) {
												return (
													<span
														key={`kwa-${Math.random()}`}
														style={{ color: "red" }}
													>
														{
															question
																.questionList[
																activeStep
															].mark
														}
													</span>
												);
											} else {
												return lbl;
											}
										}),
								]}
							</Paper>
						)}
						{question.questionList[activeStep].type === "image" && (
							<Image
								src={`${question.questionList[activeStep].src}`}
							/>
						)}
						{question.questionList[activeStep].label &&
							question.questionList[activeStep].type ===
								"image" && (
								<Typography
									variant="h5_bold"
									sx={{ mb: 2, display: "block" }}
								>
									{question.questionList[activeStep].label}
								</Typography>
							)}
						<MobileStepper
							variant="text"
							steps={maxSteps}
							position="static"
							activeStep={activeStep}
							nextButton={
								<Button
									size="small"
									onClick={handleNext}
									disabled={activeStep === maxSteps - 1}
								>
									Next
									{theme.direction === "rtl" ? (
										<KeyboardArrowLeft />
									) : (
										<KeyboardArrowRight />
									)}
								</Button>
							}
							backButton={
								<Button
									size="small"
									onClick={handleBack}
									disabled={activeStep === 0}
								>
									{theme.direction === "rtl" ? (
										<KeyboardArrowRight />
									) : (
										<KeyboardArrowLeft />
									)}
									Back
								</Button>
							}
						/>
					</Box>
					<Box
						className="choices-container"
						sx={{ px: { xs: 4, sm: 8 } }}
					>
						<FormGroup>
							{loadSelection.map((data, i) => {
								const disabled =
									Object.values(answer).indexOf(data) >= 0 &&
									answer[
										question.questionList[activeStep].name
									] !== data;
								return (
									<FormControlLabel
										sx={{ mx: 0 }}
										className={`checkbox-selection-label ${
											disabled ? "disabled" : ""
										} q-matchtext ${
											Object.values(answer).indexOf(
												data
											) >= 0
												? "selected"
												: ""
										}`}
										key={`selection-${i}-${Math.random()}`}
										checked={
											Object.values(answer).indexOf(
												data
											) >= 0
										}
										disabled={disabled}
										onClick={() => {
											if (
												!(
													Object.values(
														answer
													).indexOf(data) >= 0 &&
													answer[
														question.questionList[
															activeStep
														].name
													] !== data
												)
											)
												handleSetAnswer(
													question.questionList[
														activeStep
													].name,
													data
												);
										}}
										control={
											<Radio sx={{ display: "none" }} />
										}
										label={
											<Typography
												className="checkbox-selection-text q-matchtext-label"
												sx={{
													"&::first-letter ": {
														"text-transform":
															"capitalize",
													},
													color: "#06b6ad",
												}}
											>
												{data.toLowerCase()}
											</Typography>
										}
									/>
								);
							})}
						</FormGroup>
					</Box>
				</>
			)}
		</React.Fragment>
	);
}
